import { useRef } from 'react'
import { Outlet, useLocation, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { usePayrollBundlePageContext } from 'modules/payroll_bundle/components/PayrollBundle'
import BatchedSupplements from 'modules/payroll_bundle/components/Supplements/BatchedSupplements'
import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'
import type { RouteContextParams } from 'modules/payroll_bundle/lib/RouteContextParams'
import { useBulkImportSupplements } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { REVIEW_AND_IMPORT, SELECT_DATA } from 'modules/payroll_bundle/lib/constants'

import ImportModal from './BulkImport/_components/ImportModal'
import ManageImportedModal from './BulkImport/_components/ManageImportedModal'

type LocationState = {
  policyPeriodId: string
  employeeId: string
}

const PROGRESS_STAGES = [SELECT_DATA, REVIEW_AND_IMPORT]

const SupplementsPage = () => {
  const payrollBundleContext = usePayrollBundlePageContext()

  // useLocation().state value has to be preserved in a ref otherwise for some
  // reason it's lost when the component re-renders.
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const locationStateRef = useRef(useLocation().state as LocationState | null)
  const { showUploadModal, bulkImportSupplementStage, showManageImportedModal } =
    useBulkImportSupplements()
  const { canImportSupplements } = usePayrollContextlessPolicies()
  const { policyPeriod } = useOutletContext<RouteContextParams>()

  const bulkImportInProgress = PROGRESS_STAGES.includes(bulkImportSupplementStage)

  const locationState = locationStateRef.current

  return (
    <>
      {!bulkImportInProgress && (
        <>
          <Box gap="s8" paddingTop="s24">
            <BatchedSupplements policyPeriod={policyPeriod} itemToHighlight={locationState} />
          </Box>
          {canImportSupplements && showUploadModal && <ImportModal />}
          {canImportSupplements && showManageImportedModal && <ManageImportedModal />}
        </>
      )}

      <Outlet context={payrollBundleContext} />
    </>
  )
}

export default observer(SupplementsPage)
